<template>
  <div class="flex my-6 leading-6">
    <AtomsFormsTextInput class="flex-1 !border-r-0" id="txtSearchOrder" type="search" v-model="searchText" :placeholder="$t('Číslo objednávky, např. 6902170')" @submit="search" @keyup.enter="search" />
    <MoleculesButtonsButton :arrow-right="true" @click="search" :show-loader="loading">{{ $t('Zjistit stav') }}</MoleculesButtonsButton>
  </div>
</template>
<script setup>

const router = useRouter();
const cache = useCache();
const message = useMessage();
const locale = useLocale().getLocale();

const searchText = ref(null);

const loading = ref(false);

const search = async () => {
  if (searchText.value?.trim().length > 5) {
    loading.value = true;

    let found = false;

    //TODO: vymyslet lepsi zpusob, jak overit existenci objednavky
    try {
      const orderData = (await useApiFetch(`/api/orderDetail?orderId=${searchText.value.trim()}&currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).getOrderByToken;

      if (orderData?.id) {
        found = true;
      }
    }
    catch (e) {
      console.error(e);
    }

    if (found) {
      router.push(`${cache.getModuleUrl('modules/orderDetail')}?id=${searchText.value.trim()}`);
    }
    else {
      loading.value = false;
      message.show('Objednávka nebyla nalezena', null, true);
    }
  }
  else {
    message.show('Zadejte číslo objednávky', null, true);
  }
}

</script>